import { BaseService } from './base-service';
import {
	GetEvaluatorResponseDTO,
	GetEvaluatorRequestDTO,
	GetListEvaluatorRequestDTO,
	GetListEvaluatorResponseDTO,
	CreateEvaluatorRequestDTO,
	CreateEvaluatorResponseDTO
} from '@/core/dto';

export class EvaluatorService extends BaseService<any> {
	private static instance: EvaluatorService;

	constructor(public readonly basePath: string = '/evaluator') {
		super();
	}

	public static getInstance(): EvaluatorService {
		if (!EvaluatorService.instance) {
			EvaluatorService.instance = new EvaluatorService();
		}
		return EvaluatorService.instance;
	}

	public async show(params: GetEvaluatorRequestDTO): Promise<GetEvaluatorResponseDTO> {
		const url = this.basePath + `/${params.id}`;
		const { data } = await this.getInstance().get<GetEvaluatorResponseDTO>(url, { params });
		return data;
	}

	public async index(params: GetListEvaluatorRequestDTO): Promise<GetListEvaluatorResponseDTO> {
		const url = this.basePath + '/';
		const { data } = await this.getInstance().get<GetListEvaluatorResponseDTO>(url, { params });
		return data;
	}
	public async create(params: CreateEvaluatorRequestDTO): Promise<CreateEvaluatorResponseDTO> {
		const url = this.basePath + '/create';
		const { data } = await this.getInstance().post<CreateEvaluatorResponseDTO>(url, params);
		return data;
	}
}
